/** QuickPlan — Partage d'un projet : comptes du portail ayant accès à QuickPlan, avec
 *  pour chacun un rôle (aucun, lecteur, contributeur). Propriétaire seulement. */
import { useEffect, useState } from 'react';
import { api } from '../api/client.js';
import { useProjectStore } from '../store/useProjectStore.js';

const ROLES = [
  { id: '', label: 'Aucun accès' },
  { id: 'viewer', label: 'Lecture seule' },
  { id: 'editor', label: 'Contributeur (modifie)' },
];

export default function ShareDialog({ project, onClose }) {
  const shareProject = useProjectStore((s) => s.shareProject);
  const [users, setUsers] = useState(null);
  const [roles, setRoles] = useState(() => {
    const r = {};
    for (const u of project.sharedWith ?? []) r[u] = 'editor';
    for (const u of project.viewers ?? []) r[u] = 'viewer';
    return r;
  });
  const [extra, setExtra] = useState('');
  const [error, setError] = useState('');
  const [filter, setFilter] = useState('');

  useEffect(() => {
    api('/directory').then((d) => setUsers(d.users)).catch((e) => { setUsers([]); setError(e.message); });
  }, []);

  const all = [...new Set([...(users ?? []), ...Object.keys(roles)])]
    .filter((u) => u !== project.owner)
    .sort((a, b) => a.localeCompare(b, 'fr'));
  const shown = all.filter((u) => u.toLowerCase().includes(filter.toLowerCase()));

  const save = async () => {
    try {
      await shareProject(project.id, {
        sharedWith: Object.keys(roles).filter((u) => roles[u] === 'editor'),
        viewers: Object.keys(roles).filter((u) => roles[u] === 'viewer'),
      });
      onClose();
    } catch (e) { setError(e.message); }
  };

  return (
    <div className="modal-back" onMouseDown={onClose}>
      <div className="modal" onMouseDown={(e) => e.stopPropagation()}>
        <h2>Partager « {project.name} »</h2>
        <p className="muted">Comptes du portail ayant accès à QuickPlan. Un contributeur modifie le projet (et peut utiliser l'assistant) ; un lecteur le consulte et l'exporte.</p>
        <input className="search" placeholder="Filtrer les comptes…" value={filter} onChange={(e) => setFilter(e.target.value)} />
        <div className="share-list">
          {users === null && <div className="muted">Chargement de l'annuaire…</div>}
          {users !== null && !shown.length && <div className="muted">Aucun autre compte n'a accès à QuickPlan pour l'instant.</div>}
          {shown.map((u) => (
            <div key={u} className="share-row">
              <span className="grow">{u}{users && !users.includes(u) && <span className="muted"> (hors annuaire)</span>}</span>
              <select value={roles[u] ?? ''} onChange={(e) => setRoles({ ...roles, [u]: e.target.value })}>
                {ROLES.map((r) => <option key={r.id} value={r.id}>{r.label}</option>)}
              </select>
            </div>
          ))}
        </div>
        <div className="row">
          <input className="grow" placeholder="Autre identifiant…" value={extra} onChange={(e) => setExtra(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && extra.trim()) { setRoles({ ...roles, [extra.trim()]: 'viewer' }); setExtra(''); } }} />
          <button disabled={!extra.trim()} onClick={() => { setRoles({ ...roles, [extra.trim()]: 'viewer' }); setExtra(''); }}>Ajouter</button>
        </div>
        {error && <div className="warn">{error}</div>}
        <div className="modal-actions">
          <button onClick={onClose}>Annuler</button>
          <button className="primary" onClick={save}>Enregistrer le partage</button>
        </div>
      </div>
    </div>
  );
}
